const SESSION_ID_KEY = 'facilityup_session_id'

/**
 * Returns a stable session ID for the current browser tab/session.
 * Persisted in sessionStorage — survives page refreshes but not new tabs.
 */
export function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_ID_KEY)
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem(SESSION_ID_KEY, id)
  }
  return id
}
